__turbopack_context__.v({
  "float": "HeroSection-module-scss-module__xliFqG__float",
  "gradientBorder": "HeroSection-module-scss-module__xliFqG__gradientBorder",
  "moneyLeft": "HeroSection-module-scss-module__xliFqG__moneyLeft",
  "moneyRight": "HeroSection-module-scss-module__xliFqG__moneyRight",
});
